import React from 'react';
import useCountUp from '../hooks/useCountUp';

const AnimatedCounter = ({ end, suffix = '', prefix = '', duration = 2000, className = 'stat-number' }) => {
  // Extract numeric part for animation
  const numericEnd = typeof end === 'string' ? parseInt(end.replace(/\D/g, '')) || 0 : end;
  const originalSuffix = typeof end === 'string' ? end.replace(/\d/g, '') : '';
  
  const { count, elementRef } = useCountUp(numericEnd, duration, true);
  
  // Format the display value
  const displayValue = `${prefix}${count}${originalSuffix || suffix}`;

  return (
    <span ref={elementRef} className={className}>
      {displayValue}
    </span>
  );
};

export default AnimatedCounter;